import React from 'react';
import { Link } from 'react-router-dom';
import LandingPageExitMenu from './LandingPageExitMenu';
import { challengeWireBadgeCount } from '../../utils/landingPageChallengeBadge';

export const FITNESS_HUB_NAV_ITEMS = [
	{
		id: 'fitness-profiles',
		path: '/fitness-profiles',
		title: 'Fitness Profiles',
		icon: '🪪'
	},
	{
		id: 'challenge-wire',
		path: '/challenge-wire',
		title: 'Challenge Wire',
		icon: '⚡',
		badgeKey: 'challenges'
	}
];

function badgeCount(item, summary) {
	if (item.badgeKey === 'challenges') {
		return challengeWireBadgeCount(summary);
	}
	return 0;
}

function NavIcon({ item, active, badge, onClick, asButton, iconClassName }) {
	const className = [
		'relative w-12 h-12 flex items-center justify-center rounded-full border border-gray-200 text-white text-2xl',
		'cursor-pointer hover:scale-105 transition-transform transform backdrop-blur-md',
		active ? 'bg-blue-700 ring-2 ring-white/80' : iconClassName
	].join(' ');

	const content = (
		<>
			<span aria-hidden>{item.icon}</span>
			{badge > 0 && (
				<span className="absolute -top-1 -right-1 flex h-4 items-center justify-center rounded-full bg-red-500 px-1 text-xs font-normal leading-none text-white">
					{badge > 9 ? '9+' : badge}
				</span>
			)}
		</>
	);

	if (asButton) {
		return (
			<button type="button" className={className} onClick={onClick} title={item.title}>
				{content}
			</button>
		);
	}

	return (
		<Link to={item.path} className={className} title={item.title}>
			{content}
		</Link>
	);
}

/** Icon bar for landing hero pages — child pages use a text link back. */
export default function LandingHeroIconNav({
	items = [],
	summary = {},
	exitMenuCurrentPage,
	exitTriggerTitle = 'Leave',
	onProfilesClick,
	iconClassName = 'bg-blue-600',
	exitTriggerClassName,
	exitMenuContainerClassName = 'relative w-12 h-12',
	children
}) {
	const iconRow = (
		<div className="flex items-center justify-center gap-4 sm:gap-6 p-3 rounded-full">
			{items.map((item) => {
				const badge = badgeCount(item, summary);
				const useProfilesButton = item.id === 'fitness-profiles' && onProfilesClick;

				return (
					<NavIcon
						key={item.id}
						item={item}
						active={false}
						badge={badge}
						asButton={useProfilesButton}
						onClick={useProfilesButton ? onProfilesClick : undefined}
						iconClassName={iconClassName}
					/>
				);
			})}
			{children}
			<LandingPageExitMenu
				currentPage={exitMenuCurrentPage}
				summary={summary}
				triggerTitle={exitTriggerTitle}
				containerClassName={exitMenuContainerClassName}
				triggerClassName={
					exitTriggerClassName ||
					`w-full h-full flex items-center justify-center ${iconClassName} border border-gray-200 text-white text-2xl rounded-full cursor-pointer hover:scale-105 transition-transform transform backdrop-blur-md`
				}
			/>
		</div>
	);

	return (
		<div className="absolute bottom-2 md:bottom-4 left-1/2 z-10 -translate-x-1/2 transform">
			{iconRow}
		</div>
	);
}
